// Bump ASSET_VERSION whenever you replace/update an image to force browsers
// to re-download it (otherwise stale cached versions may be served).
const ASSET_VERSION = '?v=11';
const v = (path) => (path ? `${path}${ASSET_VERSION}` : path);

class Images{
    static memoji = v('memoji.jpg');
    static sample = '';

    static coffeeIcon = '';
    static npmIcon = '';
    static emailIcon = '';
    static twitterIcon = '';
    static linkedinIcon = '';
    static githubIcon = '';

    static appuntoIcon = v('project-icons/appuntoIcon.svg');
    static iptvisionIcon = v('project-icons/iptvisionIcon.png');
    static topperiaIcon = v('project-icons/topperiaIcon.png');
    static scarabbenIcon = v('project-icons/scarabbenIcon.png');
    static moneyIcon = v('project-icons/moneyIcon.png');
    static chatgptImageMcpIcon = v('project-icons/chatgptImageMcpIcon.svg');
    static mappinandoIcon = v('project-icons/mappinandoIcon.png');
    static chiarellaIcon = v('project-icons/chiarellaIcon.png');
    static locandingIcon = v('project-icons/locandingIcon.png');
    static nienteZombieIcon = v('project-icons/nienteZombieIcon.png');
    static piccoleGioieIcon = v('project-icons/piccoleGioieIcon.png');
    static loopingSoundsIcon = v('project-icons/loopingSoundsIcon.svg');
    static monitorSwitchIcon = v('project-icons/monitorSwitchIcon.png');
    static castinoIcon = v('project-icons/castinoIcon.png');
    static centroAscoltoIcon = v('project-icons/centroAscoltoIcon.png');
    static comicTagEditorIcon =v('project-icons/comicTagEditorIcon.png');
    static devdexIcon = v('project-icons/devdexIcon.png');
    static easyCryptAppIcon = v('project-icons/easyCryptAppIcon.png');
    static dueffeLogo = v('project-icons/dueffeLogo.png');
    static brieffoIcon = v('project-icons/brieffoIcon.png');
    static ilSognatoreIcon = v('project-icons/ilSognatoreIcon.png');
    static alexaHomeMcpIcon = v('project-icons/alexaHomeMcpIcon.svg');
    static ondalungaIcon = v('project-icons/ondalungaIcon.svg');
    static slideshowerIcon = v('project-icons/slideshowerIcon.png');
    static memshotIcon = v('project-icons/memshotIcon.png');
    static simphotosIcon = v('project-icons/simphotosIcon.png');
    static nd2Icon = v('project-icons/nd2Icon.png');
    static arcadeClassiciIcon = v('project-icons/arcadeClassiciIcon.svg');
    static hommaterialIcon = v('project-icons/hommaterialIcon.png');
    static sweepIcon = v('project-icons/sweepIcon.png');
    static easyTheaterIcon = v('project-icons/easyTheaterIcon.png');
    static garageIcon = v('project-icons/garageIcon.png');
    static healthLogo = v('project-icons/healthLogo.png');
    static ironPumpIcon = v('project-icons/ironPumpIcon.png');
    static javaLogo = v('project-icons/javaLogo.png');
    static palestraPrenotazioniIcon = v('project-icons/palestraPrenotazioniIcon.png');
    static pillolePoeticheIcon = v('project-icons/pillolePoeticheIcon.png');
    static popinAppIcon = v('project-icons/popinAppIcon.png');
    static sinceIcon = v('project-icons/sinceIcon.png');
    static sitoPalestraIcon = v('project-icons/sitoPalestraIcon.png');
    static spariapsIcon = v('project-icons/spariapsIcon.png');
    static streamwiseLogo =v('project-icons/streamwiseIcon.png');
    static streamwiseAndroidIcon = v('project-icons/streamwiseAndroidIcon.png');
    static subberAndroidIcon = v('project-icons/subberAndroidIcon.png');
    static tegliareIcon = v('project-icons/tegliareIcon.jpg');
}

export default Images;
